import * as a from './actions';
export { createInitialState, reducer } from './store';

export const actions = a;

export const fetchData = a.fetchData;
export const runRequest = a.runRequest;
export const success = a.success;
export const error = a.error;
export const start = a.start;
export const reset = a.reset;
